import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-start ga-3" }
const _hoisted_2 = { class: "flex-grow-1 min-w-0" }
const _hoisted_3 = { class: "text-subtitle-1 mb-1" }
const _hoisted_4 = {
  key: 0,
  class: "text-caption text-medium-emphasis mb-1"
}
const _hoisted_5 = { class: "text-body-2 mb-1" }
const _hoisted_6 = {
  key: 1,
  class: "text-caption mb-1 break-url"
}
const _hoisted_7 = {
  key: 2,
  class: "text-caption mb-1 break-url"
}
const _hoisted_8 = {
  key: 3,
  class: "text-caption"
}
const _hoisted_9 = { class: "manual-actions" }
const _hoisted_10 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_11 = { class: "d-flex align-center mb-3" }
const _hoisted_12 = {
  key: 0,
  class: "text-caption mt-1"
}
const _hoisted_13 = {
  key: 1,
  class: "text-caption mt-1"
}
const _hoisted_14 = { class: "text-body-2 mb-2" }
const _hoisted_15 = { class: "text-body-2 mb-2" }
const _hoisted_16 = { class: "text-body-2 mb-2" }
const _hoisted_17 = { class: "text-body-2 mb-2" }
const _hoisted_18 = {
  key: 0,
  class: "text-body-2 mb-2"
}
const _hoisted_19 = { class: "text-body-2" }
const _hoisted_20 = {
  key: 3,
  class: "mb-3"
}
const _hoisted_21 = { class: "d-flex align-center mb-3" }
const _hoisted_22 = {
  key: 0,
  class: "text-caption text-medium-emphasis"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.showDialog,
    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.showDialog) = $event)),
    "max-width": "980",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
            default: _withCtx(() => [
              _cache[21] || (_cache[21] = _createElementVNode("span", null, "Add External Server", -1)),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                icon: "",
                variant: "text",
                onClick: _ctx.close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[20] || (_cache[20] = [
                      _createTextVNode("mdi-close")
                    ])),
                    _: 1,
                    __: [20]
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1,
            __: [21]
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_tabs, {
                modelValue: _ctx.activeTab,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tab, { value: "available" }, {
                    default: _withCtx(() => _cache[22] || (_cache[22] = [
                      _createTextVNode("Available")
                    ])),
                    _: 1,
                    __: [22]
                  }),
                  _createVNode(_component_v_tab, { value: "manual" }, {
                    default: _withCtx(() => _cache[23] || (_cache[23] = [
                      _createTextVNode("Manual URL")
                    ])),
                    _: 1,
                    __: [23]
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_v_window, {
                modelValue: _ctx.activeTab,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.activeTab) = $event)),
                class: "mt-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window_item, { value: "available" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.searchQuery,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
                        label: "Search available external servers",
                        "prepend-inner-icon": "mdi-magnify",
                        variant: "outlined",
                        density: "compact",
                        clearable: ""
                      }, null, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableServers, (server) => {
                        return (_openBlock(), _createBlock(_component_v_card, {
                          key: server.name,
                          class: "mb-2 available-server-card",
                          variant: "outlined"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "py-3 px-4" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, [
                                  _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, _toDisplayString(server.displayName), 1),
                                    (server.displayName !== server.name)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Key: " + _toDisplayString(server.name), 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_5, _toDisplayString(server.description), 1),
                                    (server.url)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(server.url), 1))
                                      : _createCommentVNode("", true),
                                    (server.repositoryUrl)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(server.repositoryUrl), 1))
                                      : _createCommentVNode("", true),
                                    (server.licenseName)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(server.licenseName), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createVNode(_component_v_btn, {
                                    color: "primary",
                                    variant: "outlined",
                                    class: "available-server-card-action",
                                    onClick: ($event: any) => (_ctx.selectAvailableServer(server))
                                  }, {
                                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                                      _createTextVNode(" Install ")
                                    ])),
                                    _: 2,
                                    __: [24]
                                  }, 1032, ["onClick"])
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128)),
                      (_ctx.availableServers.length === 0 && _ctx.allAvailableServers.length === 0)
                        ? (_openBlock(), _createBlock(_component_v_alert, {
                            key: 0,
                            type: "info",
                            density: "compact",
                            variant: "tonal"
                          }, {
                            default: _withCtx(() => _cache[25] || (_cache[25] = [
                              _createTextVNode(" No shared external servers are currently available to install. ")
                            ])),
                            _: 1,
                            __: [25]
                          }))
                        : (_ctx.availableServers.length === 0)
                          ? (_openBlock(), _createBlock(_component_v_alert, {
                              key: 1,
                              type: "info",
                              density: "compact",
                              variant: "tonal"
                            }, {
                              default: _withCtx(() => _cache[26] || (_cache[26] = [
                                _createTextVNode(" No available external servers match this search. ")
                              ])),
                              _: 1,
                              __: [26]
                            }))
                          : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: "manual" }, {
                    default: _withCtx(() => [
                      (_ctx.manualError)
                        ? (_openBlock(), _createBlock(_component_v_alert, {
                            key: 0,
                            type: "error",
                            density: "compact",
                            class: "mb-3"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.manualError), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.manual.displayName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.manual.displayName) = $event)),
                        label: "Name",
                        variant: "outlined",
                        class: "mb-3 mt-2"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_textarea, {
                        modelValue: _ctx.manual.description,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.manual.description) = $event)),
                        label: "Description",
                        variant: "outlined",
                        class: "mb-3"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.manual.url,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.manual.url) = $event)),
                        label: "Remote MCP URL",
                        hint: "Must be an HTTPS streamable HTTP MCP endpoint.",
                        "persistent-hint": "",
                        variant: "outlined",
                        class: "mb-3"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_btn_toggle, {
                        modelValue: _ctx.manual.authMode,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.manual.authMode) = $event)),
                        mandatory: "",
                        divided: "",
                        class: "mb-4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, { value: "none" }, {
                            default: _withCtx(() => _cache[27] || (_cache[27] = [
                              _createTextVNode("No Auth")
                            ])),
                            _: 1,
                            __: [27]
                          }),
                          _createVNode(_component_v_btn, { value: "oauth2" }, {
                            default: _withCtx(() => _cache[28] || (_cache[28] = [
                              _createTextVNode("OAuth 2.0")
                            ])),
                            _: 1,
                            __: [28]
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _cache[52] || (_cache[52] = _createElementVNode("div", { class: "text-subtitle-2 mb-2" }, "Secrets", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.manual.secretFields, (field, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `secret-field-${index}`,
                          class: "mb-3"
                        }, [
                          _createVNode(_component_v_text_field, {
                            modelValue: field.name,
                            "onUpdate:modelValue": ($event: any) => ((field.name) = $event),
                            label: "Secret Name",
                            variant: "outlined",
                            class: "mb-2"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: field.label,
                            "onUpdate:modelValue": ($event: any) => ((field.label) = $event),
                            label: "Label",
                            variant: "outlined",
                            class: "mb-2"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: field.description,
                            "onUpdate:modelValue": ($event: any) => ((field.description) = $event),
                            label: "Description",
                            variant: "outlined",
                            class: "mb-2"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_v_checkbox, {
                            modelValue: field.required,
                            "onUpdate:modelValue": ($event: any) => ((field.required) = $event),
                            label: "Required",
                            density: "compact"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_9, [
                        (_ctx.manual.secretFields.length < 5)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              variant: "text",
                              color: "primary",
                              onClick: _ctx.addSecretField
                            }, {
                              default: _withCtx(() => _cache[29] || (_cache[29] = [
                                _createTextVNode(" Add Secret ")
                              ])),
                              _: 1,
                              __: [29]
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.manual.authMode === 'oauth2')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _cache[31] || (_cache[31] = _createElementVNode("div", { class: "text-subtitle-2" }, "Authentication Discovery", -1)),
                              _createVNode(_component_v_spacer),
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                variant: "outlined",
                                loading: _ctx.discovering,
                                onClick: _ctx.discoverAuthentication
                              }, {
                                default: _withCtx(() => _cache[30] || (_cache[30] = [
                                  _createTextVNode(" Discover Authentication ")
                                ])),
                                _: 1,
                                __: [30]
                              }, 8, ["loading", "onClick"])
                            ]),
                            _createVNode(_component_v_alert, {
                              type: "warning",
                              density: "compact",
                              variant: "tonal",
                              class: "mb-3"
                            }, {
                              default: _withCtx(() => _cache[32] || (_cache[32] = [
                                _createTextVNode(" MissionSquad discovers authorization metadata automatically in the normal flow. Manual endpoint entry is only available in the advanced section below. ")
                              ])),
                              _: 1,
                              __: [32]
                            }),
                            (_ctx.discoveryError)
                              ? (_openBlock(), _createBlock(_component_v_alert, {
                                  key: 0,
                                  type: "error",
                                  density: "compact",
                                  class: "mb-3"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, _toDisplayString(_ctx.discoveryError), 1),
                                    (_ctx.discoveryErrorCause)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Cause: " + _toDisplayString(_ctx.discoveryErrorCause), 1))
                                      : _createCommentVNode("", true),
                                    (_ctx.boundedDiscoveryAttemptedUrls.length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                          _cache[33] || (_cache[33] = _createTextVNode(" Attempted: ")),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boundedDiscoveryAttemptedUrls, (attemptedUrl) => {
                                            return (_openBlock(), _createElementBlock("div", { key: attemptedUrl }, _toDisplayString(attemptedUrl), 1))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.showIssuerOverrideFallback)
                              ? (_openBlock(), _createBlock(_component_v_card, {
                                  key: 1,
                                  variant: "outlined",
                                  class: "mb-3"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, null, {
                                      default: _withCtx(() => [
                                        _cache[35] || (_cache[35] = _createElementVNode("div", { class: "text-subtitle-2 mb-2" }, "Specify Authorization Server", -1)),
                                        _cache[36] || (_cache[36] = _createElementVNode("div", { class: "text-body-2 mb-3" }, " Use this only when the MCP server failed discovery but you know the provider's authorization server issuer URL. ", -1)),
                                        _createVNode(_component_v_text_field, {
                                          modelValue: _ctx.issuerOverrideInput,
                                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.issuerOverrideInput) = $event)),
                                          label: "Authorization Server Issuer",
                                          hint: "Enter the issuer URL. Do not enter the authorization endpoint.",
                                          "persistent-hint": "",
                                          variant: "outlined",
                                          class: "mb-3"
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_v_btn, {
                                          color: "primary",
                                          variant: "outlined",
                                          loading: _ctx.discovering,
                                          onClick: _ctx.retryDiscoveryWithIssuer
                                        }, {
                                          default: _withCtx(() => _cache[34] || (_cache[34] = [
                                            _createTextVNode(" Retry Discovery With Issuer ")
                                          ])),
                                          _: 1,
                                          __: [34]
                                        }, 8, ["loading", "onClick"])
                                      ]),
                                      _: 1,
                                      __: [35,36]
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.oauthDiscovery)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  (_ctx.oauthDiscovery.authorizationServers.length > 1)
                                    ? (_openBlock(), _createBlock(_component_v_select, {
                                        key: 0,
                                        modelValue: _ctx.selectedAuthorizationServerIssuer,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedAuthorizationServerIssuer) = $event)),
                                        items: _ctx.authorizationServerOptions,
                                        "item-title": "title",
                                        "item-value": "value",
                                        label: "Authorization Server",
                                        variant: "outlined",
                                        class: "mb-3"
                                      }, null, 8, ["modelValue", "items"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_card, {
                                    variant: "outlined",
                                    class: "mb-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card_text, null, {
                                        default: _withCtx(() => [
                                          _cache[43] || (_cache[43] = _createElementVNode("div", { class: "text-subtitle-2 mb-2" }, "Discovered Provider", -1)),
                                          _createElementVNode("div", _hoisted_14, [
                                            _cache[37] || (_cache[37] = _createElementVNode("strong", null, "Issuer:", -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.selectedAuthorizationServer?.issuer), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_15, [
                                            _cache[38] || (_cache[38] = _createElementVNode("strong", null, "Authorization Endpoint:", -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.selectedAuthorizationServer?.authorizationEndpoint), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_16, [
                                            _cache[39] || (_cache[39] = _createElementVNode("strong", null, "Token Endpoint:", -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.selectedAuthorizationServer?.tokenEndpoint), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_17, [
                                            _cache[40] || (_cache[40] = _createElementVNode("strong", null, "Default Scopes:", -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.discoveredScopesLabel), 1)
                                          ]),
                                          (_ctx.oauthDiscovery.discoverySource === 'issuer_override')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[41] || (_cache[41] = [
                                                _createElementVNode("strong", null, "Compatibility Mode:", -1),
                                                _createTextVNode(" PRM was not discovered. OAuth resource URI will use the canonical MCP URL. ")
                                              ])))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", _hoisted_19, [
                                            _cache[42] || (_cache[42] = _createElementVNode("strong", null, "Registration Mode:", -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.registrationModeSummary), 1)
                                          ])
                                        ]),
                                        _: 1,
                                        __: [43]
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.canUseAutomaticRegistration)
                                    ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                        key: 1,
                                        modelValue: _ctx.manual.useManualClientCredentials,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.manual.useManualClientCredentials) = $event)),
                                        label: "Use manual client ID / secret",
                                        density: "compact",
                                        class: "mb-3"
                                      }, null, 8, ["modelValue"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.availableRegistrationModeOptions.length > 0)
                                    ? (_openBlock(), _createBlock(_component_v_select, {
                                        key: 2,
                                        modelValue: _ctx.manual.selectedRegistrationMode,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.manual.selectedRegistrationMode) = $event)),
                                        items: _ctx.availableRegistrationModeOptions,
                                        "item-title": "title",
                                        "item-value": "value",
                                        label: "Registration Mode",
                                        variant: "outlined",
                                        class: "mb-3"
                                      }, null, 8, ["modelValue", "items"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.manualClientCredentialsEntryEnabled)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                        _createVNode(_component_v_text_field, {
                                          modelValue: _ctx.manual.oauthClientConfig.clientId,
                                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.manual.oauthClientConfig.clientId) = $event)),
                                          label: "Client ID",
                                          variant: "outlined",
                                          class: "mb-3"
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_v_text_field, {
                                          modelValue: _ctx.manual.oauthClientConfig.clientSecret,
                                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.manual.oauthClientConfig.clientSecret) = $event)),
                                          label: "Client Secret",
                                          variant: "outlined",
                                          class: "mb-3"
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_v_text_field, {
                                          modelValue: _ctx.manual.defaultScopes,
                                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.manual.defaultScopes) = $event)),
                                          label: "Scopes Override",
                                          hint: "Comma-separated. Leave blank to use the discovered default scope set.",
                                          "persistent-hint": "",
                                          variant: "outlined"
                                        }, null, 8, ["modelValue"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_expansion_panels, {
                              variant: "accordion",
                              class: "mt-4"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_expansion_panel, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_expansion_panel_title, null, {
                                      default: _withCtx(() => _cache[44] || (_cache[44] = [
                                        _createTextVNode("Advanced Manual OAuth Setup")
                                      ])),
                                      _: 1,
                                      __: [44]
                                    }),
                                    _createVNode(_component_v_expansion_panel_text, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_alert, {
                                          type: "warning",
                                          density: "compact",
                                          variant: "tonal",
                                          class: "mb-3"
                                        }, {
                                          default: _withCtx(() => _cache[45] || (_cache[45] = [
                                            _createTextVNode(" This bypasses discovery. Use it only when the provider metadata cannot be discovered automatically. ")
                                          ])),
                                          _: 1,
                                          __: [45]
                                        }),
                                        _createVNode(_component_v_text_field, {
                                          modelValue: _ctx.manual.manualOAuth.authorizationEndpoint,
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.manual.manualOAuth.authorizationEndpoint) = $event)),
                                          label: "Authorization Endpoint",
                                          variant: "outlined",
                                          class: "mb-3"
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_v_text_field, {
                                          modelValue: _ctx.manual.manualOAuth.tokenEndpoint,
                                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.manual.manualOAuth.tokenEndpoint) = $event)),
                                          label: "Token Endpoint",
                                          variant: "outlined",
                                          class: "mb-3"
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_v_text_field, {
                                          modelValue: _ctx.manual.oauthClientConfig.clientId,
                                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.manual.oauthClientConfig.clientId) = $event)),
                                          label: "Client ID",
                                          variant: "outlined",
                                          class: "mb-3"
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_v_text_field, {
                                          modelValue: _ctx.manual.oauthClientConfig.clientSecret,
                                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.manual.oauthClientConfig.clientSecret) = $event)),
                                          label: "Client Secret",
                                          variant: "outlined",
                                          class: "mb-3"
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_v_text_field, {
                                          modelValue: _ctx.manual.defaultScopes,
                                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.manual.defaultScopes) = $event)),
                                          label: "Scopes Override",
                                          hint: "Comma-separated optional scopes.",
                                          "persistent-hint": "",
                                          variant: "outlined"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card, {
                              variant: "outlined",
                              class: "mt-4"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_text, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_21, [
                                      _cache[48] || (_cache[48] = _createElementVNode("div", { class: "text-subtitle-2" }, "Authorization Request Parameters", -1)),
                                      _createVNode(_component_v_spacer),
                                      _createVNode(_component_v_btn, {
                                        variant: "text",
                                        color: "secondary",
                                        onClick: _ctx.applyGoogleAuthorizationRequestParams
                                      }, {
                                        default: _withCtx(() => _cache[46] || (_cache[46] = [
                                          _createTextVNode(" Use Google Defaults ")
                                        ])),
                                        _: 1,
                                        __: [46]
                                      }, 8, ["onClick"]),
                                      _createVNode(_component_v_btn, {
                                        variant: "text",
                                        color: "primary",
                                        onClick: _ctx.addAuthorizationRequestParam
                                      }, {
                                        default: _withCtx(() => _cache[47] || (_cache[47] = [
                                          _createTextVNode(" Add Parameter ")
                                        ])),
                                        _: 1,
                                        __: [47]
                                      }, 8, ["onClick"])
                                    ]),
                                    _cache[50] || (_cache[50] = _createElementVNode("div", { class: "text-body-2 mb-3" }, [
                                      _createTextVNode(" Use this for provider-specific authorization URL params such as Google's "),
                                      _createElementVNode("code", null, "access_type=offline"),
                                      _createTextVNode(" or "),
                                      _createElementVNode("code", null, "prompt=consent"),
                                      _createTextVNode(". ")
                                    ], -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.manual.authorizationRequestParams, (param, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: `authorization-request-param-${index}`,
                                        class: "d-flex align-center ga-3 mb-3"
                                      }, [
                                        _createVNode(_component_v_text_field, {
                                          modelValue: param.name,
                                          "onUpdate:modelValue": ($event: any) => ((param.name) = $event),
                                          label: "Parameter Name",
                                          variant: "outlined",
                                          density: "compact",
                                          "hide-details": ""
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                        _createVNode(_component_v_text_field, {
                                          modelValue: param.value,
                                          "onUpdate:modelValue": ($event: any) => ((param.value) = $event),
                                          label: "Parameter Value",
                                          variant: "outlined",
                                          density: "compact",
                                          "hide-details": ""
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                        _createVNode(_component_v_btn, {
                                          icon: "",
                                          variant: "text",
                                          color: "error",
                                          onClick: ($event: any) => (_ctx.removeAuthorizationRequestParam(index))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, null, {
                                              default: _withCtx(() => _cache[49] || (_cache[49] = [
                                                _createTextVNode("mdi-delete")
                                              ])),
                                              _: 1,
                                              __: [49]
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]))
                                    }), 128)),
                                    (_ctx.manual.authorizationRequestParams.length === 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, " No provider-specific authorization params configured. "))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1,
                                  __: [50]
                                })
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        class: "manual-submit-button",
                        onClick: _ctx.continueToInstall
                      }, {
                        default: _withCtx(() => _cache[51] || (_cache[51] = [
                          _createTextVNode("Create & Install")
                        ])),
                        _: 1,
                        __: [51]
                      }, 8, ["onClick"])
                    ]),
                    _: 1,
                    __: [52]
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}